import { ReactElement } from 'react'
import styled from 'styled-components'

type EarlyAccessBannerProps = {
  title: string
  color: string
  description?: string | React.ReactNode
  cta?: ReactElement
  testId?: string
}

export const EarlyAccessBanner = ({
  title,
  color,
  description,
  cta,
  testId
}: EarlyAccessBannerProps): ReactElement => (
  <Wrapper color={color} data-testid={testId}>
    <TextWrapper>
      <BannerTitle>{title}</BannerTitle>
      <BannerDescription>{description}</BannerDescription>
    </TextWrapper>
    {cta}
  </Wrapper>
)

const Wrapper = styled.div`
  background-color: ${(props) => props.color};
  color: ${({ theme }) => theme.color.neutral.color11};
  width: 100%;
  padding: 8px 24px;
  margin-top: 24px;
  border-radius: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`
const TextWrapper = styled.div`
  display: flex;
  align-items: center;
`

const BannerTitle = styled.div`
  font-size: 18px;
  font-weight: 700;
  margin-right: 24px;
`
const BannerDescription = styled.div`
  font-size: 16px;
  font-weight: 400;
  ${({ theme }) => theme.mediaQueries.tabletDown} {
    display: none;
  }
`
export default EarlyAccessBanner
